import { Checkbox, List, ListItem, Typography } from '@material-ui/core';
import React from 'react';
import { FilterProps, ValidOption } from '../types';

const OptionFilter = (props: FilterProps<'options'>) => {
  const {state, setState, options, validate, setValid} = props;

  const [selectedOptions, setSelectedOptions] = React.useState<ValidOption[]>(state && state.options || []);

  // For faster access in the map. Prevents O(n^2) map
  const selectedOptionSet = React.useMemo(() => new Set(selectedOptions), [selectedOptions]);

  const onSelect = (opt: ValidOption) => () => {
    if(selectedOptionSet.has(opt)) {
      setSelectedOptions(selectedOptions.filter(o => o !== opt));
    } else {
      setSelectedOptions([...selectedOptions, opt])
    }
  }

  React.useEffect(() => {
    if(validate) {
      setState({options: selectedOptions})
      setValid(true)
    }
  }, [validate])

  return <List disablePadding>
    {options.map(opt => <ListItem
      dense
      key={opt.key == null ? 'null':opt.key.toString()}
    >
      <Checkbox
        checked={selectedOptionSet.has(opt.key)}
        color='primary'
        onChange={onSelect(opt.key)}
        size='small' />
      <Typography>{opt.value}</Typography>
    </ListItem>)}
  </List>;
};

export default OptionFilter;